export const getSearchTerm = state => (state.documentSearch.searchTerm);

export const getSearchTermErrors = state => (state.documentSearch.errors && state.documentSearch.errors.searchTerm);

export const getValidationGlobalErrors = state => (state.documentSearch.globalErrors);

export const getResults = state => (state.documentSearch.page ? state.documentSearch.page.content : []);

export const isLastPage = state => (state.documentSearch.page ? state.documentSearch.page.last : true);

export const getTotalResults = state => (state.documentSearch.page ? state.documentSearch.page.totalElements : 0);

export const getTotalPages = state => (state.documentSearch.page ? state.documentSearch.page.totalPages : 0);

export const getResultsShowing = state => (state.documentSearch.page && state.documentSearch.page.content ? state.documentSearch.page.content.length : 0);

export const getPageStart = state => (state.documentSearch.pageNumber);

export const isSearchLoading = state => (state.documentSearch.searchLoading);

